const SOCURE_RESPONSE_STATUS = {
  DOCUMENTS_UPLOADED: 'DOCUMENTS_UPLOADED',
  VERIFICATION_COMPLETE: 'VERIFICATION_COMPLETE',
  VERIFYING: 'VERIFYING',
  WAITING_FOR_UPLOAD: 'WAITING_FOR_UPLOAD',
};
const VERIFICATION_STAGES = ['Progress Started', 'Document Uploaded', 'Verification Complete'];

export { SOCURE_RESPONSE_STATUS, VERIFICATION_STAGES };
